<thehubz-history [resourceId]="collectionId" [tableType]="'Collection'"></thehubz-history>
